// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__LQfvI","widgetTitle":"Sidebar_widgetTitle__4V7qp","section":"Sidebar_section__IH4UY","link":"Sidebar_link__B9Pj1"};